<template>
	<div style="width: 100%">
		<h1>Formulaire</h1>
		<b-form inline>
			<b-input-group prepend="Nom">
				<b-form-input v-model="name"></b-form-input>
			</b-input-group>
			<b-input-group prepend="Version">
				<b-form-input v-model="version"></b-form-input>
			</b-input-group>
			<b-button v-b-modal="'modal' + id">Charger</b-button>
			<b-button @click="save_db" :disabled="!version || !name"
				><i class="fas fa-save"></i
			></b-button>
			<b-button v-b-modal="'modal_file' + id">Fichier</b-button>
			<b-button v-b-modal="'modal_rename' + id">Renommer</b-button>
		</b-form>

		<b-modal :hide-footer="true" :id="'modal' + id" title="Charger">
			<span>Nom</span>
			<v-select v-model="load_name" :options="names"></v-select>
			<span>Version</span>
			<v-select
				v-model="load_version"
				:options="versions"></v-select>
		</b-modal>

		<b-modal :hide-footer="true" :id="'modal_file' + id" title="Fichier">
			<b-file
				accept=".json"
				@change="load_file"
				placeholder="charger (fichier)"></b-file>
			<br /><br />
			<b-button @click="save">sauvergarder (fichier)</b-button>
		</b-modal>

		<b-modal :hide-footer="true" :id="'modal_rename' + id" title="Renommer">
			<p>Nouveau nom</p>
			<b-input v-model="new_name"></b-input>
			<br />
			<b-button @click="rename">Rennomer</b-button>
		</b-modal>

		<div>
			<br />
			<b-button :variant="(tab == 'form') ? 'success' : 'secondary'" @click="tab = 'form'">{{ is_zones_form ? "Editeur visuel" : "Formulaire"}}</b-button>&nbsp;
			<span v-if="is_zones_form">
				<b-button :variant="(tab == 'parameters') ? 'success' : 'secondary'" @click="tab = 'parameters'">Formulaire</b-button>&nbsp;
			</span>
			<b-button :variant="(tab == 'scenario') ? 'success' : 'secondary'" @click="tab = 'scenario'">Scénario de création</b-button>&nbsp;
			<b-button :variant="(tab == 'scenario_result') ? 'success' : 'secondary'" @click="tab = 'scenario_result'">Scénario de résultat</b-button>
			<br /><br />
		</div>

		<div v-show="tab == 'form' || tab == 'parameters'" content-class="mt-3">
			<p v-if="!is_zones_form || tab == 'parameters'"><b-checkbox style="display:inline" v-model="is_zones_form" :value="true" :unchecked-value="false"></b-checkbox>Editeur visuel</p>
		
			<div v-if="is_zones_form == true">
				<zones_form ref="visual_editor"  @update="visual_update"></zones_form>
			</div>

			<create_form ref="create_form" @update="update" :minimal="(!is_zones_form || tab == 'parameters') ? false : true"></create_form>
		</div>

		<div v-show="tab == 'scenario'">
			<br />
			<project
				ref="scenario"
				initial_method_prop="fichiers"
				:config="false"
				:config_name="true"
				state_prop="etape"></project>
		</div>

		<div v-show="tab == 'scenario_result'">
			<br />
			<project
				ref="scenario_result"
				initial_method_prop="fichiers"
				:config="false"
				:config_name="true"
				state_prop="etape"></project>
		</div>
	</div>
</template>

<script>
	import uniqueId from "lodash.uniqueid";

	var clone = require("clone");

	import create_form from "../components/create_form.vue";
	import zones_form from "../components/zones_form.vue";
	import element from "../services/element.js";
	import users from "../services/users.js";
	import utils from "../services/utils.js";
	import project from "./Project.vue";
	import store from "../store";
	
	export default {
		name: "form",
		components: {
			zones_form,
			create_form,
			project,
		},
		data() {
			return {				
				form: {},
				type: "",
				name: "",
				new_name: name,
				names: [],
				versions: [],
				version: "",
				load_name: "",
				load_version: "",
				id: uniqueId(),
				tab: "form",
				is_zones_form: false
			};
		},
		watch: {
			index: {
				async handler() {},
			},
			type: {
				async handler() {
					this.set_name();
				},
			},
			load_name: {
				async handler() {
					var elements = await element.getby_libelle(
						this.load_name,
						this.type
					);
					elements = elements.element;

					this.versions = [];
					for (var i = 0; i < elements.length; i++) {
						if (i == 0) {
							if (
								this.load_version &&
								this.load_version == elements[i].version
							)
								await this.load_db();
							this.load_version = elements[i].version;
						}
						this.versions.push(elements[i].version);
					}
				},
			},
			load_version: {
				async handler() {
					if (this.load_version) await this.load_db();
				},
			},
		},
		methods: {
			async rename() {
				console.log("rename");
				await element.rename(this.type, this.name, this.new_name);
				this.name = this.new_name;
				this.save_db();
			},
			async set_name() {
				var names = await element.getby_production(this.type);
				names = names.element;

				this.names = [];
				for (var i = 0; i < names.length; i++) {
					this.names.push(names[i].libelle);
				}
			},
			async save_db() {
				console.log("save_db")
				var data = await this.save(false);

				this.$refs.scenario.update_name(this.name);
				this.$refs.scenario.set_version(this.version);
				await this.$refs.scenario.save_db(false, false);

				this.$refs.scenario_result.update_name(this.name + "_result");
				this.$refs.scenario_result.set_version(this.version);
				await this.$refs.scenario_result.save_db(false, false);

				await element.save(this.name, this.version, data, this.type);
				await this.set_name();
			},
			async save(file = true) {
				var data = {
					name: this.name,
					is_zones_form: this.is_zones_form
				};

				if (this.is_zones_form)
					data.zones_form = await this.$refs.visual_editor.save()

				data.form = await this.$refs["create_form"].save();

				this.$refs.scenario.update_name(this.name);
				this.$refs.scenario.update_version(this.version);

				data.scenario = await this.$refs.scenario.save(false);

				this.$refs.scenario_result.update_name(this.name + "_result");
				this.$refs.scenario_result.update_version(this.version);

				data.scenario_result = await this.$refs.scenario_result.save(false);

				if (file)
				{
					utils.saveToFile(
						JSON.stringify(data),
						(this.name ? this.name : "form") + ".json"
					);
				}
				else
				{
					console.log(data)
					return data
				}
			},
			async load(data, db = false) {
				var self = this;

				console.log(data)

				this.name = data.name;
				this.is_zones_form = data.is_zones_form || false;
				
				await this.$refs["create_form"].load(data.form)

				self.$nextTick(async function () {

					if (data.scenario && !db)
					{
						console.log("--- load scenario ---")
						await self.$refs.scenario.load(data.scenario);
					}
					else
					{
						console.log("--- load db ---")
						await self.$refs.scenario.load_db(
							self.name,
							self.version
						);
					}

					if (data.scenario_result && !db)
					{
						console.log("--- load scenario result ---")				
						await self.$refs.scenario_result.load(data.scenario_result);
					}
					else
					{
						console.log("--- load scenario result ---")
						await self.$refs.scenario_result.load_db(
							self.name + "_result",
							self.version
						);
					}
					
					if (self.is_zones_form)
					{
						await self.$refs.visual_editor.load(data.zones_form);
					}
				});
			},
			async load_db() {
				console.log("load_db")
				console.log(this.load_name, this.load_version, this.type)

				document.body.style.cursor = "wait";
				var result = await element.load(
					this.load_name,
					this.load_version,
					this.type
				);

				console.log(result)

				this.name = this.load_name;
				this.version = this.load_version;
				await this.load(result, true);
				document.body.style.cursor = "default";
			},
			async load_file(event) {
				var self = this;

				var file = "";
				if (event.dataTransfer) file = event.dataTransfer.files[0];
				else file = event.target.files[0];

				var reader = new FileReader();

				reader.onload = (function (theFile) {
					return function (e) {
						var data = JSON.parse(e.target.result);
						self.load(data);
					};
				})(file);

				reader.readAsText(file);
			},
			update(code)
			{
				var data = this.$refs.scenario.getStepParametersByDescription("Génération de formulaire");
				console.log(data)
				if (data)
				{
					data.html = code;
					this.$refs.scenario.updateStepParametersByDescription("Génération de formulaire", data);
				}
			},
			visual_update(form)
			{
				console.log("visual_update");
				this.$refs.create_form.set_form(form);
			}
		},
		mounted: async function () {
			if (store.state.user.rules && !store.state.user.rules.form) {
				this.$router.push({ name: "profile" });
			}

			var self = this;

			var response = await users.getSelf(true);
			var client = response.client;
			if (client.details && client.details.formulaire)
				this.form = client.details.formulaire;

			this.type = "scenario_form";

			await this.$refs.scenario.addStep({
				"data": {
					"parameters": {
						"type": "template",
						"html": "",
						"extension": "",
						"name": "",
						"column": "url_form",
						"url": true
					},
					"action": "html",
					"label": "Générer document",
					"sql_rules": ""
				},
				"description": "Génération de formulaire",
				"action": "html",
				"actionLabel": "Générer document",
				"c_conditions": false,
				"c_tree": false,
				"c_project": false,
				"project_id": "",
				"c_parameters": true,
				"c_tabulator": false,
				"c_test": true,
				"tabulator2": [],
				"keep_start_data": false,
				"option_delete": false,
				"option_make_list": false,
				"treatment": false,
				"source_data": "",
				"currentRequest": null
			});


			await this.$refs.scenario.addStep({
				"data": {
					"action": "fonction",
					"label": "Script personnalisé",
					"parameters": {
						"type": "line",
						"code": `
data.name = "Formulaire"

data.project_uid = "${this.$refs.scenario_result.geProjectUid()}";
data.uid = uuidv4();
data.env = message.header.env || null;
data.url = "${this.form.url_form}/${client.uid}" + (data.env ? "/" + data.env : "") + "/" + data.uid;
						`
					},
				},
				"description": "Préparation à la mise en db",
				"action": "fonction",
				"actionLabel": "Script personnalisé",
				"c_conditions": true,
				"c_tree": false,
				"c_project": false,
				"project_id": "",
				"c_parameters": true,
				"c_tabulator": false,
				"c_test": true,
				"tabulator2": [],
				"keep_start_data": false,
				"option_delete": false,
				"option_make_list": false,
				"treatment": false,
				"source_data": "",
				"currentRequest": null
			});

			await this.$refs.scenario.addStep({
				"data": {
					"uid": "97c161c8-bf2d-494f-8343-48b033eb310e",
					"parameters": {
						"type": "insérer",
						"table": this.form.table,
						"colonnes": [
							{
								"colonne": "url_form",
								"mapping": "url_form"
							},
							{
								"colonne": "name",
								"mapping": "name"
							},
							{
								"colonne": "project_uid",
								"mapping": "project_uid"
							},
							{
								"colonne": "uid",
								"mapping": "uid"
							},
							{
								"colonne": "env",
								"mapping": "env"
							},
							{
								"colonne": "url",
								"mapping": "url"
							}
						],
						"colonnes_unique": [],
						"response_column": "response"
					},
					"action": "base de données",
					"label": "Base de données",
					"sql_rules": "",
					"notifications": {
						"formulaire": "client"
					}
				},
				"description": "",
				"action": "base de données",
				"actionLabel": "Base de données",
				"c_conditions": true,
				"c_tree": false,
				"c_project": false,
				"project_id": "",
				"c_parameters": true,
				"c_tabulator": false,
				"c_test": true,
				"tabulator2": [],
				"keep_start_data": false,
				"option_delete": false,
				"option_make_list": false,
				"treatment": false,
				"source_data": "",
				"currentRequest": null
			});

			await this.$refs.scenario_result.addStep({
				"data": {
					"uid": "a8ec21d7-03ec-4408-9d48-94941ddda017",
					"parameters": {
						"type": "line",
						"code": "data.active = 0;",
						"strict": false,
						"cut_start": false,
						"cut_end": false
					},
					"action": "fonction",
					"label": "Script personnalisé",
					"sql_rules": ""
				},
				"description": "",
				"action": "fonction",
				"actionLabel": "Script personnalisé",
				"c_conditions": true,
				"c_tree": false,
				"c_project": false,
				"project_id": "",
				"c_parameters": true,
				"c_tabulator": false,
				"c_test": true,
				"tabulator2": [],
				"keep_start_data": false,
				"option_delete": false,
				"option_make_list": false,
				"treatment": false,
				"source_data": "",
				"currentRequest": null
			});

			await this.$refs.scenario_result.addStep({
				"data": {
					"uid": "45d6ba7f-a6ea-4671-bdd6-4122ffd606cb",
					"parameters": {
						"token": "uLXDJPDvyRcNEz9A",
						"type": "mettre à jour",
						"table": "formulaire",
						"colonnes": [
							{
								"colonne": "uid",
								"mapping": "uid"
							},
							{
								"colonne": "active",
								"mapping": "active"
							}
						],
						"colonnes_unique": [
							"uid"
						],
						"response_column": "response"
					},
					"action": "base de données",
					"label": "Base de données",
					"sql_rules": "",
					"notifications": {
						"formulaire": "client"
					}
				},
				"description": "Mise à jour en db",
				"action": "base de données",
				"actionLabel": "Base de données",
				"c_conditions": true,
				"c_tree": false,
				"c_project": false,
				"project_id": "",
				"c_parameters": true,
				"c_tabulator": false,
				"c_test": true,
				"tabulator2": [],
				"keep_start_data": false,
				"option_delete": false,
				"option_make_list": false,
				"treatment": false,
				"source_data": "",
				"currentRequest": null
			});
		},
	};
</script>

<style scoped>
	.center_spinner {
		width: 0%;
		margin: 0 auto;
		margin-top: 30px;
	}
</style>
